<template>
<!-- :class="{accordeon__active: open}" -->
    <el-collapse-item
        class="accordeon"
        :name="item"
    >
    <template slot="title">
      <div class="accordeon_title" v-html="content.text" /> 
    </template>

        <div class="accordeon_content" >
            <div class="content_title" >
                ОТРАСЛИ ЭКОНОМИКИ И ВЕДУЩИЕ РАБОТОДАТЕЛИ
            </div>

            <div class="department_w">
                <div class="department_l">
                    <img :src="`${$server}p2/${content.id}/b1.svg`" />
                </div>
                <div class="department_r" v-if="content.department">
                    <div class="accordeon_subtitle" v-html="content.department.title" />
                    <ul class="body_ul">
                        <li v-for="li of content.department.list" v-html="li" />
                    </ul>
                </div>
            </div>

            <div class="divide_m" />

            <div class="content_title" >
                ПРОФЕССИОНАЛЬНО ВАЖНЫЕ КАЧЕСТВА И КОМПЕТЕНЦИИ:
            </div>

            <ul class="content_list">
                <li v-for="item of content.list" v-html="item" />
            </ul>

        </div>
    </el-collapse-item>
</template>
<script>
export default {
    name: 'Page2Accordeon',
    data () {
        return {
            open: false,
        }
    },
    props: {
        content: Object,
        item: Number,
    },
    methods: {
        onOpen () {
            this.open = true
        }
    }
}
</script>
<style lang="stylus">
@import '../cofig.styl'

.accordeon
    // border 1px solid red
    margin-bottom 40px
    .department_w
        display flex
        flex-wrap wrap
        justify-content space-between
        align-items center
        padding-top 15px
        @media screen and (max-width: 800px)
            flex-direction column

        .department_l
            width 50%
            @media screen and (max-width: 800px)
                width 100%
                margin-bottom 10px

            img
                width 100%
        .department_r
            width 47%
            @media screen and (max-width: 800px)
                width 100%

    .accordeon_title
        width 100%
        $fontTitle()
        // font-weight bold
        padding 10px 20px
        color $color
        background: rgb(199,234,251);
        background: linear-gradient(90deg, rgba(199,234,251,1) 0%, rgba(255,255,255,1) 100%);
        cursor pointer
        transition color .5s
        &:hover
            color $colorSel
        @media screen and (max-width: 800px)
            padding 10px 15px 10px 10px
    .accordeon_subtitle
        // $fontTitle()
        font-size 18px
        line-height 24px
        text-transform uppercase
        color $color
        margin-bottom 8px
        @media screen and (max-width: 800px)
            font-size 4vw
            line-height 5.5vw


    .accordeon_content
        padding 0 20px
        @media screen and (max-width: 800px)
            padding 0

.el-collapse-item.accordeon.is-active
    .accordeon_title
        $fontH2()
        padding 8px 20px
        // color $colorSel
        @media screen and (max-width: 800px)
            padding 10px
.el-collapse .el-collapse-item__wrap
    background-color: rgb(248, 252, 254, 0.5);
.divide_m
    height 40px


</style>